import React from "react";
import { RaceProgram, RaceWagerType } from "@tvg/ts-types/Race";
import { getWagerTypesNames } from "@tvg/utils/betSelection";
import { useDispatch } from "react-redux";
import { breakpoints, useMediaQuery } from "@tvg/design-system";
import {
  isAllSelected,
  selectAllRunners,
  deselectAllRunners
} from "./utils/utils";
import SimpleSelections from "./SimpleSelections";
import DropdownSelections from "./DropdownSelections";
import MobileDropdownSelections from "./MobileDropdownSelections";
import useGetRunnerFromBI from "../../../../hooks/useGetRunnerFromBI";
import { filterHKRaces } from "../../../../utils/raceUtils";
import { betButtonClickEvent } from "../../../../utils/gtm/selection";

interface SelectAllProps {
  currentRace: RaceProgram;
  selectedBetType: RaceWagerType;
  isScrollableRacecard?: boolean;
  leg?: number;
  selections: string[][];
}

const SelectAll = ({
  currentRace,
  selectedBetType,
  isScrollableRacecard,
  selections,
  leg = 0
}: SelectAllProps) => {
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);
  const dispatch = useDispatch();
  const { bettingInterests: raceBI, numWagerableRunners } = currentRace;
  const bettingInterests = isMobile ? filterHKRaces(currentRace) : raceBI;
  const betLabels: Array<string> = isScrollableRacecard
    ? ["Select all"]
    : getWagerTypesNames(selectedBetType);

  const runners =
    bettingInterests &&
    useGetRunnerFromBI(bettingInterests, {
      withComputedProps: true
    });

  const isSelected: boolean[] =
    selectedBetType &&
    selections &&
    isAllSelected(selections, selectedBetType, numWagerableRunners);

  const onClickSelectAll = (position: number, isAlreadySelected: boolean) => {
    const pos = isScrollableRacecard ? leg : position;
    if (isAlreadySelected) {
      deselectAllRunners(pos, selections, dispatch);
    } else {
      selectAllRunners(pos, selectedBetType, selections, dispatch, runners);
      betButtonClickEvent({
        module: "wps_select_all_modal",
        option: selectedBetType.group.name,
        betTypeCode: selectedBetType.group.code,
        currentRace
      });
    }
  };

  const sharedProps = {
    selectionLabels: betLabels,
    betType: selectedBetType,
    isAllSelected: isSelected,
    onClickSelectAll
  };

  if (isMobile) {
    return (
      <MobileDropdownSelections
        {...sharedProps}
        isScrollableRacecard={isScrollableRacecard}
        leg={leg}
      />
    );
  }

  return betLabels.length > 3 ? (
    <DropdownSelections {...sharedProps} />
  ) : (
    <SimpleSelections
      {...sharedProps}
      isScrollableRacecard={isScrollableRacecard}
      leg={leg}
    />
  );
};

export default SelectAll;
